import React from 'react';
import './styles.scss';
import { CallToAction } from 'components/atoms/callToAction';

const JoinOurTeamStatement = props => {
  const { onClick, showButton = true } = props;

  return (
    <div className={'join-our-team-statement'}>
      <div className={'section-statements'}>
        <h1 className={'section-heading'}>Want to build the future with us?</h1>
        {showButton && (
          <div className={'section-header'}>
            <CallToAction
              mode={'light'}
              className={'section-header-item'}
              text={'VIEW ALL ROLES'}
              onClick={e => onClick(true)}
            />
          </div>
        )}
        <p className={'content'}>
          The only prerequisite is passion. Bring your fresh ideas, new
          perspectives and individual spirit to the table. We can’t wait to hear
          from you.
        </p>
      </div>
    </div>
  );
};

export default JoinOurTeamStatement;
